import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksEditRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-edit',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
	exact: true,
};
